var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "yqt-image" }, [
    _vm.lazyload
      ? _c(
          "img",
          _vm._g(
            _vm._b(
              {
                directives: [
                  {
                    name: "lazy",
                    rawName: "v-lazy",
                    value: _vm.lazyloadObj,
                    expression: "lazyloadObj",
                  },
                ],
                key: "lazyload-img",
                staticClass: "yqt-image__inner",
                class: {
                  "yqt-image__inner--center": _vm.alignCenter,
                },
                style: _vm.imageStyle,
              },
              "img",
              _vm.$attrs,
              false
            ),
            _vm.$listeners
          )
        )
      : _c(
          "img",
          _vm._g(
            _vm._b(
              {
                key: "default-img",
                staticClass: "yqt-image__inner",
                class: {
                  "yqt-image__inner--center": _vm.alignCenter,
                },
                style: _vm.imageStyle,
                attrs: { src: _vm.src },
              },
              "img",
              _vm.$attrs,
              false
            ),
            _vm.$listeners
          )
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }